import {TeamPlanLeadFormEvent} from './team-plan-lead-form-event';

/**
 * Amplitude event fired when the Team Plan sign-up form submission succeeds.
 */
export class TeamPlanLeadFormSubmissionSucceededEvent extends TeamPlanLeadFormEvent {
    constructor(formId: string) {
        super('tp_lead_form_submission_succeeded', formId);
    }
}
